/**
 * Contenido de la tabla comparativa de planes.
 *
 * Cada plan se representa con tres valores, uno por columna (START, PRO,
 * ELITE): `true` cuando lo incluye, `false` cuando no, y un texto cuando la
 * diferencia es de nivel (por ejemplo, el tipo de soporte).
 */
export const planComparison = {
  ES: {
    title: 'Qué incluye cada plan.',
    subtitle: 'Desliza en horizontal para comparar los tres planes y ver qué ganas en cada paso.',
    prev: 'Ver planes anteriores',
    next: 'Ver más planes',
    groups: [
      {
        name: 'LO ESENCIAL',
        rows: [
          { label: 'Software TPV HIOPOS', values: [true, true, true] },
          { label: 'Ventas y caja', values: [true, true, true] },
          { label: 'Productos y tarifas', values: [true, true, true] },
          { label: 'Clientes', values: [true, true, true] },
          { label: 'Informes esenciales', values: [true, true, true] },
          { label: 'Copias de seguridad y actualizaciones', values: [true, true, true] },
        ],
      },
      {
        name: 'CONTROL Y CRECIMIENTO',
        rows: [
          { label: 'Software adicional según sector', values: [false, true, true] },
          { label: 'Gestión avanzada', values: [false, true, true] },
          { label: 'Estadísticas ampliadas', values: [false, true, true] },
          { label: 'Herramientas digitales para clientes', values: [false, true, true] },
          { label: 'Servicios adicionales SmartPOS', values: [false, true, true] },
        ],
      },
      {
        name: 'ESCALA',
        rows: [
          { label: 'Módulos avanzados seleccionados', values: [false, false, true] },
          { label: 'Integraciones seleccionadas', values: [false, false, true] },
          { label: 'Multi-punto de venta y ERP', values: [false, false, true] },
          { label: 'Servicios SmartPOS Premium', values: [false, false, true] },
        ],
      },
      {
        name: 'SOPORTE',
        rows: [
          { label: 'Soporte técnico', values: ['Estándar', 'Prioritario', 'Prioritario'] },
          { label: 'SLA', values: ['Básico', 'Mejorado', 'Premium'] },
        ],
      },
    ],
  },
  CA: {
    title: 'Què inclou cada pla.',
    subtitle: 'Llisca en horitzontal per comparar els tres plans i veure què guanyes a cada pas.',
    prev: 'Veure plans anteriors',
    next: 'Veure més plans',
    groups: [
      {
        name: 'LO ESSENCIAL',
        rows: [
          { label: 'Programari TPV HIOPOS', values: [true, true, true] },
          { label: 'Vendes i caixa', values: [true, true, true] },
          { label: 'Productes i tarifes', values: [true, true, true] },
          { label: 'Clients', values: [true, true, true] },
          { label: 'Informes essencials', values: [true, true, true] },
          { label: 'Còpies de seguretat i actualitzacions', values: [true, true, true] },
        ],
      },
      {
        name: 'CONTROL I CREIXEMENT',
        rows: [
          { label: 'Programari addicional segons sector', values: [false, true, true] },
          { label: 'Gestió avançada', values: [false, true, true] },
          { label: 'Estadístiques ampliades', values: [false, true, true] },
          { label: 'Eines digitals per a clients', values: [false, true, true] },
          { label: 'Serveis addicionals SmartPOS', values: [false, true, true] },
        ],
      },
      {
        name: 'ESCALA',
        rows: [
          { label: 'Mòduls avançats seleccionats', values: [false, false, true] },
          { label: 'Integracions seleccionades', values: [false, false, true] },
          { label: 'Multi-punt de venda i ERP', values: [false, false, true] },
          { label: 'Serveis SmartPOS Premium', values: [false, false, true] },
        ],
      },
      {
        name: 'SUPORT',
        rows: [
          { label: 'Suport tècnic', values: ['Estàndard', 'Prioritari', 'Prioritari'] },
          { label: 'SLA', values: ['Bàsic', 'Millorat', 'Premium'] },
        ],
      },
    ],
  },
  EN: {
    title: 'What each plan includes.',
    subtitle: 'Swipe sideways to compare the three plans and see what you gain at each step.',
    prev: 'See previous plans',
    next: 'See more plans',
    groups: [
      {
        name: 'THE ESSENTIALS',
        rows: [
          { label: 'HIOPOS POS software', values: [true, true, true] },
          { label: 'Sales and cash', values: [true, true, true] },
          { label: 'Products and prices', values: [true, true, true] },
          { label: 'Customers', values: [true, true, true] },
          { label: 'Essential reports', values: [true, true, true] },
          { label: 'Backups and updates', values: [true, true, true] },
        ],
      },
      {
        name: 'CONTROL & GROWTH',
        rows: [
          { label: 'Extra software by sector', values: [false, true, true] },
          { label: 'Advanced management', values: [false, true, true] },
          { label: 'Extended statistics', values: [false, true, true] },
          { label: 'Digital tools for customers', values: [false, true, true] },
          { label: 'Additional SmartPOS services', values: [false, true, true] },
        ],
      },
      {
        name: 'SCALE',
        rows: [
          { label: 'Selected advanced modules', values: [false, false, true] },
          { label: 'Selected integrations', values: [false, false, true] },
          { label: 'Multi-location and ERP', values: [false, false, true] },
          { label: 'SmartPOS Premium services', values: [false, false, true] },
        ],
      },
      {
        name: 'SUPPORT',
        rows: [
          { label: 'Technical support', values: ['Standard', 'Priority', 'Priority'] },
          { label: 'SLA', values: ['Basic', 'Improved', 'Premium'] },
        ],
      },
    ],
  },
  FR: {
    title: 'Ce que comprend chaque offre.',
    subtitle: 'Faites défiler horizontalement pour comparer les trois offres et voir ce que vous gagnez à chaque étape.',
    prev: 'Voir les offres précédentes',
    next: 'Voir plus d’offres',
    groups: [
      {
        name: "L'ESSENTIEL",
        rows: [
          { label: 'Logiciel TPV HIOPOS', values: [true, true, true] },
          { label: 'Ventes et caisse', values: [true, true, true] },
          { label: 'Produits et tarifs', values: [true, true, true] },
          { label: 'Clients', values: [true, true, true] },
          { label: 'Rapports essentiels', values: [true, true, true] },
          { label: 'Sauvegardes et mises à jour', values: [true, true, true] },
        ],
      },
      {
        name: 'CONTRÔLE ET CROISSANCE',
        rows: [
          { label: 'Logiciels supplémentaires selon le secteur', values: [false, true, true] },
          { label: 'Gestion avancée', values: [false, true, true] },
          { label: 'Statistiques étendues', values: [false, true, true] },
          { label: 'Outils numériques pour les clients', values: [false, true, true] },
          { label: 'Services SmartPOS supplémentaires', values: [false, true, true] },
        ],
      },
      {
        name: 'ÉVOLUTION',
        rows: [
          { label: 'Modules avancés sélectionnés', values: [false, false, true] },
          { label: 'Intégrations sélectionnées', values: [false, false, true] },
          { label: 'Multi-points de vente et ERP', values: [false, false, true] },
          { label: 'Services SmartPOS Premium', values: [false, false, true] },
        ],
      },
      {
        name: 'SUPPORT',
        rows: [
          { label: 'Support technique', values: ['Standard', 'Prioritaire', 'Prioritaire'] },
          { label: 'SLA', values: ['Basique', 'Amélioré', 'Premium'] },
        ],
      },
    ],
  },
};